import {Clock, DateTimeFormatter, LocalDate, ZonedDateTime} from "js-joda";
import React from "react";

//JsJoda doesn't support month names
export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function asLocalDate(dateISOString, clock = Clock.systemDefaultZone()) {
    if (!dateISOString) {
        return "";
    }
    const date = LocalDate.parse(dateISOString);
    return date.format(DateTimeFormatter.ofPattern('dd ')) + months[date.monthValue() - 1] + " " + date.year();
}

export function asLocalTime(dateTimeISOString, clock = Clock.systemDefaultZone()) {
    if (!dateTimeISOString) {
        return "";
    }
    const zoneId = clock.zone();
    const zonedDateTime = ZonedDateTime.parse(dateTimeISOString).withZoneSameInstant(zoneId);
    const today = LocalDate.now(clock);
    const day = zonedDateTime.toLocalDate();
    if (!today.equals(day)) {
        return asLocalDateTime(dateTimeISOString, clock);
    }
    return zonedDateTime.format(DateTimeFormatter.ofPattern("HH:mm:ss"));
}

export function asLocalDateTime(dateTimeISOString, clock = Clock.systemDefaultZone()) {
    if (!dateTimeISOString) {
        return "";
    }
    const zoneId = clock.zone();
    const zonedDateTime = ZonedDateTime.parse(dateTimeISOString).withZoneSameInstant(zoneId);
    const day = zonedDateTime.format(DateTimeFormatter.ofPattern("dd"));
    const month = months[zonedDateTime.monthValue() - 1];
    const year = zonedDateTime.year();
    const time = zonedDateTime.format(DateTimeFormatter.ofPattern("HH:mm"));
    return `${day} ${month} ${year} ${time}`;
}

export default function howLongAgo(dateTimeISOString, clock = Clock.systemDefaultZone()) {
    if (!dateTimeISOString) {
        return "";
    }
    const today = LocalDate.now(clock);
    const zoneId = clock.zone();
    const eventDate = ZonedDateTime.parse(dateTimeISOString).withZoneSameInstant(zoneId);
    if (eventDate.toLocalDate().compareTo(today) !== 0) {
        return eventDate.format(DateTimeFormatter.ofPattern('dd ')) + months[eventDate.monthValue() - 1];
    } else {
        return eventDate.format(DateTimeFormatter.ofPattern('HH:mm'));
    }
}
